import { generateURL, showMobileFilterButton } from "./offers";
import { ACTUAL_FILTER } from "./settings";

$(() => {
  $("#oportunitiesForm a").removeAttr('href');

  $(document).on("click", "#oportunitiesForm [list-item][isInexperienced]", (event) => {
    event.preventDefault();
    event.stopPropagation();

    const target = event.currentTarget;
    if (ACTUAL_FILTER.isInexperienced) {
      ACTUAL_FILTER.isInexperienced = null;
      $("input", target).prop('checked', false);
    } else {
      ACTUAL_FILTER.isInexperienced = true;
      $("input", target).prop('checked', true);
    }
    innerWidth > 767
      ? generateURL()
      : showMobileFilterButton();
  });

  $(document).on("click", "#oportunitiesForm [list-item][isUntrained]", (event) => {
    event.preventDefault();
    event.stopPropagation();

    const target = event.currentTarget;
    if (ACTUAL_FILTER.isUntrained) {
      ACTUAL_FILTER.isUntrained = null;
      $("input", target).prop('checked', false);
    } else {
      ACTUAL_FILTER.isUntrained = true;
      $("input", target).prop('checked', true);
    }
    window.innerWidth > 767
      ? generateURL()
      : showMobileFilterButton();
  });

  $(document).on("click", "#oportunitiesForm [list-item][isVehicleNeeded]", (event) => {
    event.preventDefault();
    event.stopPropagation();
    
    const target = event.currentTarget;
    if (ACTUAL_FILTER.isVehicleNeeded != null && ACTUAL_FILTER.isVehicleNeeded === false) {
      ACTUAL_FILTER.isVehicleNeeded = null;
      $("input", target).prop('checked', false);
    } else {
      ACTUAL_FILTER.isVehicleNeeded = false;
      $("input", target).prop('checked', true);
    }
    window.innerWidth > 767
      ? generateURL()
      : showMobileFilterButton();
  });
});
